// extracted by mini-css-extract-plugin
export default {"panel":"ResultPanel_panel__oyNs0"};